<template>
  <div class="about">
    <div class="bg">
      <video src="@/assets/top-bg-video.mp4" autoplay loop muted ref="video" v-if="!$store.state.isMobile"></video>
      <div class="title">WORMHOLE</div>
      <div class="content">Enabling amazing success since 2007.</div>
    </div>
    <div class="article">
      <p>Wormhole is a game publishing label established and owned by Zhejiang Jinke Culture Industry Co., LTD. (“Jinke Culture”), a public-listed company with a market cap of over 2.2 billion USD.</p>
      <p>Jinke Culture was founded in June 2007 and listed on the Shenzhen Stock Exchange, China, in May 2015. Two years later, Jinke Culture acquired Outfit7, a global mobile game industry leader and the creator of the successful Talking Tom and Friends IP, giving Jinke Culture exclusive rights on the IP’s usage. This opened up even more business opportunities for the group in the segments of education, entertainment, licensing and merchandising, as well as retail.</p>
      <p>Under the leadership and ownership of Jinke Culture, Outfit7 created games like the worldwide sensations, My Talking Tom Friends, My Talking Tom 2, Talking Tom Hero Dash, and more. Today, the multinational entertainment company has 14 billion global downloads and up to 410 million MAU. </p>
      <p>On September 1, 2020, Mr Monte Singman – a veteran of the global gaming industry – officially joined Jinke Culture as CEO of Jinke International (Hong Kong) and Senior Vice President of Jinke Guangzhou. During his career, Mr Singman has achieved great success in the Chinese market, helping to license Monument Valley, Toy Blast, GardenScapes, HomeScapes, Super Animal Royale, Art of War, Chef Blast with Gordon Ramsay, and other world-renowned games.</p>
      <p>Moving forwards, it is Mr Singman’s intention to devote himself to bringing more world-class games and IPs to China, and provide the company with strategic support. As part of his vision, Jinke Culture established Wormhole, a new game publishing label, with a mission to work with developers from all over the world and bring the best games to China. </p>
    
      <img src="@/assets/advantage-bg.png" class="left-circle">
      <img src="@/assets/advantage-bg.png" class="right-circle">
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    if(!this.$store.state.isMobile) {
      this.$refs.video.play()
    }
  },
}
</script>

<style lang="stylus" scoped>
.about
  background #fff

.bg
  position relative
  height 438px
  background url('../assets/top-bg.png') no-repeat center top
  background-size cover
  color #ffffff
  text-align center
  display flex
  flex-direction column
  justify-content center

  @media screen and (max-width: 769px)
    justify-content flex-start

  .title
    position relative
    font-size 64px
    font-weight 300

    @media screen and (max-width: 769px)
      font-size 35px
      margin-top 100px
  
  .content
    position relative
    font-size 24px
    max-width 1000px
    margin 70px auto 0 auto

    @media screen and (max-width: 769px)
      font-size 18px

  video 
    position absolute
    left 50%
    top 0
    transform translateX(-50%)

    @media screen and (max-width: 769px)
      display none
    

.article
  position relative
  font-size 24px
  max-width 860px
  margin 0 auto
  padding 130px 10px

  @media screen and (max-width: 769px)
    font-size 18px
    line-height 1.5
    padding 100px 22px
  
  p
    line-height 32px
    

  img 
    width 100%

  .left-circle, .right-circle
    position absolute
    width 290px
    height 290px

  .left-circle
    left -300px
    bottom 100px
    transform rotate(-80deg)

  .right-circle
    right -300px
    top 80px
    transform rotate(80deg)

</style>

